
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.71 17.71a.99.99 0 01-1.4 0L10 11.4l-6.31 6.31a.99.99 0 11-1.4-1.4L8.6 10 2.29 3.69a.99.99 0 111.4-1.4L10 8.6l6.31-6.31a.99.99 0 111.4 1.4L11.4 10l6.31 6.31a.99.99 0 010 1.4z"}})])
          )
        }
      }
    